import React, { useState } from 'react';
import styled from 'styled-components';
import { Like } from 'styled-icons/boxicons-solid';
import { Eye } from 'styled-icons/evaicons-solid';
import { Popup } from '@progress/kendo-react-popup';
import Grid from '@material-ui/core/Grid';
import { Info } from 'styled-icons/fluentui-system-regular';
// eslint-disable-next-line import/no-extraneous-dependencies
import PropTypes from 'prop-types';
import { palette } from '../../../../system/styles/styles';

function PostsCard({ data, activeEdit, activeDelete, className }) {
  const [state, setState] = useState({
    show: false,
  });

  const anchor = React.useRef();
  const contentRef = React.useRef();
  const blurTimeoutRef = React.useRef();

  const handleClose = () => {
    setState((prevState) => ({ ...prevState, anchorEl: null }));
  };

  const onOpen = () => {
    contentRef.current.focus();
  };

  const onFocus = () => {
    // the user is still inside the content
    clearTimeout(blurTimeoutRef.current);
  };

  const onBlurTimeout = () => {
    // the user is now outside the popup
    setState((prev) => ({ ...prev, show: false }));
  };

  const onBlur = () => {
    clearTimeout(blurTimeoutRef.current);

    blurTimeoutRef.current = setTimeout(onBlurTimeout, 200);
  };

  const handleClick = () => {
    setState({
      show: true,
    });
  };

  console.log(data)
  return (
    <Grid item xl={4} lg={4}>
      <div className={`${className} vacancyCard`}>
        <article className="job">
          <div>
            <div className="job-image" style={{ backgroundImage: `url(${data.img})` }} />
            <div className="job-content">
              <div className="job-base">
                <h3>{data.postTitle}</h3>
                <button type="button" onClick={handleClick} ref={anchor} className="viewMore-btn">
                  <Info size={20} color="#fff" />
                </button>
                <Grid container>
                  <Grid item lg={2} className="anItem">
                    <Like className="iconItem" size={20} />
                    <p className="textItem">{data.likes}</p>
                  </Grid>
                  <Grid item lg={2} className="anItem">
                    <Eye className="iconItem" size={20} />
                    <p className="textItem">{data.views}</p>
                  </Grid>
                </Grid>
              </div>
            </div>
          </div>
        </article>
        <Popup anchor={anchor.current} show={state.show} onOpen={onOpen} popupClass="popup-content">
          <div ref={contentRef} onFocus={onFocus} onBlur={onBlur}>
            <button onClick={() => activeEdit(data)} type="button">
              Editar
            </button>
            <button
              onClick={() => {
                activeDelete(data);
                handleClose();
              }}
              type="button">
              Eliminar
            </button>
          </div>
        </Popup>
      </div>
    </Grid>
  );
}

PostsCard.propTypes = {
  data: PropTypes.objectOf(PropTypes.any),
  className: PropTypes.string,
  activeEdit: PropTypes.func,
  activeDelete: PropTypes.func,
};

PostsCard.defaultProps = {
  data: {},
  className: '',
  activeEdit: () => {},
  activeDelete: () => {},
};

export default styled(PostsCard)`
  font-family: "Sofia Pro", Sans-serif;
  box-shadow: 0px 2px 30px #00000029;
  border-radius: 8px;
  margin-top: 32px;
  .vacancyCard {
    width: 90%;
    display: flex;
    padding: 10px;
    justify-content: space-between;
    align-items: center;
    margin: 25px auto;
    border-radius: 8px;
  }
  .cardContent {
    width: 80%;
    display: flex;
    justify-content: space-around;
    img {
      width: 18%;
      height: 120px;
    }
  }
  .dataContainer {
    display: flex;
    flex-direction: column;
    padding: 10px;
    width: 31%;
  }
  .jobTitle {
    font-size: 1.7rem !important;
    padding: 3px 0px;
    margin: 0px;
  }
  .companyName {
    font-size: 1.5rem !important;
    padding: 3px 0px;
    margin: 0px;
  }
  .contract {
    font-size: 1.7rem !important;
    padding: 3px 0px;
    margin: 0px;
  }
  .seeMore {
    font-size: 14px !important;
    color: #fff !important;
    background-color: #22545b;
    padding: 8px 12px;
    margin: 0px;
    font-weight: 600;
    cursor: pointer;
    border-radius: 8px;
  }
  .viewMore-btn {
    background-color: #22545b;
    width: 32px;
    height: 32px;
    border-radius: 8px;
    padding: 4px;
    position: absolute;
    top: -13px;
    right: 3.5%;
    box-shadow: 0 2.8px 2.2px rgba(0, 0, 0, 0.02), 0 6.7px 5.3px rgba(0, 0, 0, 0.028),
    0 12.5px 10px rgba(0, 0, 0, 0.035), 0 22.3px 17.9px rgba(0, 0, 0, 0.042), 0 41.8px 33.4px rgba(0, 0, 0, 0.05),
    0 100px 80px rgba(0, 0, 0, 0.07);
    &:hover {
      cursor: pointer;
    }
    svg {
      display: table;
      margin: 0 auto;
    }
  }
  .vacancyImage {
    width: 18%;
    height: 120px;
  }
  .cardAction {
    width: 20%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .deleteButton {
    padding: 8px 12px;
    font-size: 14px !important;
    color: ${palette.white};
    background: ${palette.red};
    width: 100%;
  }
  img {
    width: 256px;
    margin: 32px auto;
    display: table;
  }
  .job {
    position: relative;
    background: #e9e9e9;
    border: 0 solid rgba(0, 0, 0, 0.125);
    border-radius: 0.2rem;
    box-shadow: 0 5px 20px 0 rgb(0 0 0 / 15%);
    backface-visibility: hidden;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    transition: all ease-in-out 1s;
    transform: translateY(0);
    width: 100%;
    a {
      text-decoration: none !important;
      user-select: none;
      &:hover {
        cursor: pointer;
      }
    }
    p {
      font-size: 14px !important;
      margin-bottom: 12px;
    }
    h1 {
      font-size: 20px !important;
    }
    .job-image {
      position: relative;
      display: block;
      height: 250px;
      width: 100%;
      overflow: hidden;
      flex: 0 0 auto;
      background-size: cover;
      background-position: center center;
      background-repeat: no-repeat;
    }
    .job-content {
      background-color: #fff;
      position: relative;
      display: flex;
      flex-direction: column;
      flex: 1 1 auto;
      padding: 0 16px;
    }
    .job-base {
      position: relative;
      z-index: 2;
      background-color: #fff;
      padding: 32px 16px 24px 16px;
      flex: 0 0 auto;
      h3 {
        font-size: 20px !important;
        color: #0d5c1d;
        margin-bottom: 12px;
        font-family: 'Cooper Md BT', serif;
      }
      h4 {
        font-family: 'Sofia Pro', sans-serif;
        letter-spacing: 1px;
        font-weight: 400;
        font-size: 16px;
      }
    }
`;
